import React from "react";
import CalendarReminder from "../Calendar/CalendarReminder";

const SevenDaysReminder = ({ isLoading, reminderList }) => {
  // when reminder is loading!
  if (isLoading && !reminderList) {
    return <p>Loading...</p>;
  }

  // when NO reminder found!
  if (!isLoading && (!reminderList || reminderList.length === 0)) {
    return <p>No reminders found.</p>;
  }

  return (
    <>
      <div className="p-5">
        {/* Cards */}
        {reminderList?.map((schedule, index) => (
          <div id={index} key={index}>
            <CalendarReminder schedule={schedule} />
          </div>
        ))}
      </div>
    </>
  );
};

export default SevenDaysReminder;
